import React from 'react'
import Text from '../Text'
import FilterSelect from '../FilterSelect'
import './styles.scss'

export const FiltersHeader = ({ title, filters, activeFilter, setActiveFilter }) => {
  return (
    <div className="filters-header d-flex justify-content-between">
      <div>
        <Text.Header size="large">{title}</Text.Header>
      </div>
      <div className="filters-dropdown">
        <FilterSelect filters={filters} activeFilter={activeFilter} onChange={setActiveFilter} />
      </div>
    </div>
  )
}

export default FiltersHeader